import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { TaasVhvData } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { VhvActions } from '../vhvActions';
import { IAppState } from '../appState';
import { buildTaasVHVDataForStrecke } from './transformer/vhvData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasVhvData>;

export function* streckenTarifierungVHV(): Generator<ForkEffect> {
  const requestActions = [
    TARIF_CHECKED,
    ZUSATZOPTION_CHECKED,
    ZUSATZOPTION_UNCHECKED,
    VhvActions.PREISE_REQUESTED,
    VhvActions.VERSSUMME_FAHRRAD_CHANGED,
    VhvActions.SELBSTBETEILIGUNG_CHANGED,
    VhvActions.WERTSACHENSUMMEN_CHANGED,
    VhvActions.WERTSACHENSUMME_CHANGED,
    VhvActions.MAP_COORDINATES_VHV_CHANGED_ANGEBOT,
  ];
  const successActions = [
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VHV,
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VHV,
  ];

  streckenTarifierer = new StreckenTarifierer(
    {
      appId: App.VHV,
      successEventWithInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VHV,
      successEventWithoutInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VHV,
      errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_VHV,
    },
    buildTaasVHVDataForStrecke,
    shouldCancelRequest,
    createHashedRelevantRiskdataVHV,
  );

  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.VHV));
  yield takeEvery(successActions, safeSaga(streckenTarifierer.handleSuccess, App.VHV));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_VHV,
    safeSaga(streckenTarifierer.handleError, App.VHV),
  );
}

export function shouldCancelRequest(state: IAppState): boolean {
  return !state.wertsachensummen;
}

export function createHashedRelevantRiskdataVHV(taasData: TaasVhvData): string {
  const relevantData = { ...taasData };

  delete relevantData.gisDaten;
  delete relevantData.salesProducts;
  delete relevantData.spartenType;
  delete relevantData.versicherungssumme;
  delete relevantData.versicherungssummenRad;
  delete relevantData.entschaedigungsgrenzeWertsachenBetrag;

  return createHashedTaasData(relevantData);
}
